import { useEffect, useMemo, useState } from 'react'

const DEFAULT_SIZES = [10, 25, 50] as const

export function useClientPagination<T>(
  items: T[],
  defaultPageSize = 10,
  pageSizeOptions: readonly number[] = DEFAULT_SIZES
) {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(defaultPageSize)

  useEffect(() => {
    setPage(1)
  }, [items.length, pageSize, items])

  const total = items.length
  const pageCount = Math.max(1, Math.ceil(total / pageSize) || 1)
  const safePage = Math.min(Math.max(1, page), pageCount)
  const start = (safePage - 1) * pageSize
  const pageItems = useMemo(
    () => items.slice(start, start + pageSize),
    [items, start, pageSize]
  )

  const from = total === 0 ? 0 : start + 1
  const to = Math.min(start + pageSize, total)

  return {
    page: safePage,
    pageSize,
    pageSizeOptions,
    total,
    pageCount,
    pageItems,
    from,
    to,
    setPage,
    setPageSize: (size: number) => {
      setPageSize(size)
      setPage(1)
    },
    showPager: total > pageSize,
  }
}
